import bem from 'utils/bem';

export const block = bem('tier-selection-modal');
